import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ethers } from "ethers";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ConfirmPopup from "../../../Components/ConfirmPopup";
import WeaponFeature from "../Collection/WeaponFeature";
import { IconWrapper } from "../../../Components/StyledComponents/StyledComponents";
import {
  Button,
  ButtonWrapper,
  Container,
  HeadingTextcontainer,
  NftGridContainer,
  NftGridWrapper,
  NftNameText,
  NftNameWrapper,
  NftNewArival,
  NftCategory,
  NftNewArivalWrapper,
  PriceButtonContainer,
  PriceText,
  Pricevalue,
  PriceWrapper,
  Text,
  TextWrapper,
  ViewAllWrapper,
  ViewButton,
  NftNameTextWrapper,
  NftCountText,
  } from "../NftmarketGridStyledComponent";
import {
  getName,
  totalSupply,
  getNFTInfo,
  nftInfo,
  } from "./contractData";

import {
  nftContractABI,
  metaspaceNFTMarketplaceAddress,
  metaspaceNFTMarketplaceABI,
  } from "../../../config/data";

import CircularLoader from "../../../Components/CircularLoader/CircularLoader";
import environmentVariables from "../../../config/environmentVariables";
const PoolIcon = `${environmentVariables?.cdnUrl}new.png`;

const Root = styled.div``;

const Icon = styled.img`
  width: 26px;
  height: 26px;
  aspect-ratio: auto 1/1;
`;

const NftArrivals = ({ isHome, allContractDetails }) => {
  const [loading, setLoading] = useState(false);
  const [showCreatedPopup, setShowCreatedPopup] = useState(false);
  const [allNftContract, setAllNftContract] = useState([]);
  const [allSupportedNftContract, setAllSupportedNftContract] = useState([]);
  const [arrivalList, setArrivalList] = useState([]);
  const [allFeaturedData, setAllFeaturedData] = useState({});
  const [newdata, setNewData] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isCarouselStopped, setIsCarouselStopped] = useState(false);
  const navigation = useNavigate();

  var settings = {
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    afterChange: (current) => {
      setCurrentSlide(current);
      setIsCarouselStopped(true);
    },
    beforeChange: () => {
      setIsCarouselStopped(false);
    },
    styled: {
      margin: "20px",
    },
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
        },
      },

      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 540,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const NewArrivalHandle = () => {
    let url = allContractDetails?.address
      ? `${
          environmentVariables?.redisUrl
        }/nftmarketplace/api/v1/getnftbyskinid?address=${allContractDetails?.address.toLowerCase()}`
      : `${environmentVariables?.redisUrl}/nftmarketplace/api/v1/getnftbyskinid`;
    axios
      .get(url)
      .then((res) => {
        setNewData(res.data.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    setLoading(true);
    NewArrivalHandle();
  }, [allContractDetails]);

  const getNFTContract = async (nftAddress) => {
    return new ethers.Contract(
      nftAddress,
      nftContractABI,
      allContractDetails?.signer
    );
  };


  const fetchNftDetail = async (address, index, url) => {
    const response = await axios.get(`${url}${address}/${index}`);
    return response.data;
  };

  const fetchFeaturedData = async (supportedArr) => {
    const obj = {};
    supportedArr.map(async (contract) => {
      const nftContract = await getNFTContract(contract);
      await getName(nftContract)
        .then(async (nftContractName) => {
          const metaspaceBaseApiURL = `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/get_token_details/`;
          await totalSupply(nftContract)
            .then(async (supplyCount) => {
              let i = 0;
              while (i < Number(supplyCount)) {
                if (i === 100) {
                  setAllFeaturedData({ ...obj });
                  return;
                }
                await nftInfo(
                  allContractDetails?.metaspaceNFTMarketplaceContract,
                  contract.toLowerCase(),
                  i
                )
                  .then(async (nftContractInfo) => {
                    if (Number(nftContractInfo.listingStage) !== 0) {
                      const nftDetail = await fetchNftDetail(
                        contract.toLowerCase(),
                        i,
                        metaspaceBaseApiURL
                      );
                      const dataList = obj[nftContractName]?.data || [];
                      const detailsList =
                        obj[nftContractName]?.fetchDetails || [];
                      obj[nftContractName] = {
                        ...obj[nftContractName],
                        supply: Number(supplyCount),
                        contract,
                        i,
                        fetchDetails: [...detailsList, nftDetail],
                        data: [...dataList, nftContractInfo],
                      };

                      if (obj[nftContractName].data.length === 8) {
                        setAllFeaturedData({ ...obj });
                        return;
                      }
                    } else {
                      obj[nftContractName] = {
                        ...obj[nftContractName],
                        supply: Number(supplyCount),
                      };
                    }
                    i++;
                  })
                  .catch((err) => {
                    setAllFeaturedData({ ...obj });
                    i++;
                    console.log("err", err);
                  });
              }

              // console.log("obj", obj);
              setAllFeaturedData({ ...obj });
            })
            .catch((err) => {
              console.log("err inside a totalsupply", err);
            });
        })
        .catch((err) => {
          console.log("err inside a getName", err);
        });
    });

    return obj;
  };

  const getFinalData = async (a) => {
    let arr = [];
    const metaspaceBaseApiURL = `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/get_token_details/`;
    a.map(async (data) => {
      try {
        if (data?.args["nftAddress"] && Number(data?.args["tokenId"])) {
          const nftInfo = await getNFTInfo(
            allContractDetails?.metaspaceNFTMarketplaceContract,
            data?.args["nftAddress"],
            Number(data?.args["tokenId"])
          );
          if (nftInfo) {
            const nftDetail = await fetchNftDetail(
              data.args["nftAddress"].toLowerCase(),
              parseInt(data.args["tokenId"]),
              metaspaceBaseApiURL
            );
            arr.push({
              arg: data.args,
              nftDetail,
            });
          }
        }
      } catch (err) {
        console.log("err", err);
      }
      // console.log("arr", arr);
      setArrivalList([...arr]);
    });

    return arr;
  };

  const fetchNewArrivalData = async () => {
    const fromBlock = 36767745;
    const provider = new ethers.JsonRpcProvider(
      "https://polygon-mainnet.infura.io/v3/a8460c2c0aca48fa96e428d41e7cd71e"
    );

    const contract = new ethers.Contract(
      metaspaceNFTMarketplaceAddress,
      metaspaceNFTMarketplaceABI,
      provider
    );
    const filter = contract.filters.NftListed(null, null, null);

    const a = await contract.queryFilter(filter, fromBlock, "latest");

    // console.log("a", a);
    const finalArr = getFinalData(a);

    // console.log("finalArr", finalArr);
    return finalArr;
  };

  const getAllNftMarketplaceList = async () => {
    setShowCreatedPopup(false);
    setAllNftContract([]);
    setAllSupportedNftContract([]);
    await fetchNewArrivalData();

    if (location.pathname === "/nftMarket") {
      let i = 0;
      let arr = [];
      let supportArr = [];
      await fetchFeaturedData(supportArr);
    } else {
      console.log("inside else portion");
    }
  };

  return (
    <>
      <Root>
        <Container>
          <HeadingTextcontainer>
            <TextWrapper>
              <Text>
                <IconWrapper>
                  <Icon src={PoolIcon} />
                </IconWrapper>{" "}
                NEW ARRIVALS
              </Text>
            </TextWrapper>
            {isHome?<ViewAllWrapper
              onClick={() =>
                navigation("/nftMarket")
              }
            >
              <ViewButton>View All</ViewButton>
            </ViewAllWrapper>:<></>}
          </HeadingTextcontainer>

          <NftGridContainer>
            {loading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularLoader></CircularLoader>
              </div>
            ) : (
              <>
                <Slider key={newdata.length} initialSlide={0} {...settings}>
                  {newdata?.map((newArrivaldata, index) => {
                    return (
                      <>
                        <NftGridWrapper key={index}>
                          <NftNewArivalWrapper                         
                            onClick={() => {                            
                              if (newArrivaldata?.isFixed === true) {
                                navigation(
                                  `/nftdetails/${
                                    newArrivaldata?.contractAddress
                                  }/${parseInt(newArrivaldata?.tokenId)}`
                                );
                              } else {
                                navigation(
                                  `/specificnft/${
                                    newArrivaldata?.contractAddress
                                  }/${parseInt(newArrivaldata?.tokenId)}`
                                );
                              }
                            }}
                          >
                            <NftCategory
                              common={newArrivaldata?.category === "common"}
                              uncommon={newArrivaldata?.category === "uncommon"}
                            >
                              {newArrivaldata?.category=="uncommon"?"rare":newArrivaldata?.category}
                            </NftCategory>
                            <NftNewArival
                              src={`${environmentVariables?.cdnUrl}${newArrivaldata?.skinId}.png`}
                            />
                          </NftNewArivalWrapper>
                          <NftNameWrapper>
                            <NftNameTextWrapper>
                              <NftNameText> {newArrivaldata?.name} </NftNameText>
                              <NftCountText>{`${newArrivaldata?.count} Left`}</NftCountText>
                            </NftNameTextWrapper>
                          </NftNameWrapper>

                          <PriceButtonContainer>
                            <PriceWrapper PriceText>
                              <PriceText>{`Best price`} </PriceText>
                              <Pricevalue>
                                {" "}
                                {`${newArrivaldata?.price} ${newArrivaldata?.currency=="MLD"||newArrivaldata?.currency=="LORD"?"$":""}${newArrivaldata?.currency}`}{" "}
                              </Pricevalue>
                            </PriceWrapper>
                            <ButtonWrapper
                              onClick={() => {
                                if (newArrivaldata?.isFixed === true) {
                                  navigation(
                                    `/nftdetails/${
                                      newArrivaldata?.contractAddress
                                    }/${parseInt(newArrivaldata?.tokenId)}`
                                  );
                                } else {
                                  navigation(
                                    `/specificnft/${
                                      newArrivaldata?.contractAddress
                                    }/${parseInt(newArrivaldata?.tokenId)}`
                                  );
                                }
                              }}
                            >
                              <Button>
                                {newArrivaldata?.isFixed === true
                                  ? "Place a Bid"
                                  : "Buy Now"}
                              </Button>
                            </ButtonWrapper>
                          </PriceButtonContainer>
                        </NftGridWrapper>
                      </>
                    );
                  })}
                </Slider>
              </>
            )}
          </NftGridContainer>
        </Container>

        {location.pathname === "/nftMarket" && (
          <WeaponFeature
            data={allFeaturedData}
            allContractDetails={allContractDetails}
          />
        )}

        {showCreatedPopup && (
          <ConfirmPopup
            showPopup={showCreatedPopup}
            setShowPopup={setShowCreatedPopup}
            onClickFun={getAllNftMarketplaceList}
            text={`Congratulation you get data successfully.`}
          ></ConfirmPopup>
        )}
      </Root>
    </>
  );
};

export default NftArrivals;
